<template>
    <div class="b_article_single simple-page">
        <div class="container">
            <div class="article_wrapper">
                <div class="wrapper_inner">
                    <div class="article_section">
                        <h1>{{ title }}</h1>
                        <content-builder :value="content" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { StatusCodes } from 'http-status-codes';
import headMixin from '@/mixins/head.mixin.js';
import ContentBuilder from '@/components/elements/ContentBuilder';

export default {
    components: {
        ContentBuilder
    },

    mixins: [headMixin],

    async asyncData({ store: { dispatch }, params: { slug }, error }) {
        try {
            const { content, meta, title } = await dispatch('pages/show', slug);

            return { title, content, meta };
        } catch (err) {
            if (
                err.response &&
                err.response.status !== StatusCodes.INTERNAL_SERVER_ERROR
            ) {
                return error({ statusCode: err.response.status });
            }

            console.error(err);

            return error({ statusCode: StatusCodes.INTERNAL_SERVER_ERROR });
        }
    }
};
</script>
